import { faFaceSmileTear } from "@fortawesome/pro-regular-svg-icons/faFaceSmileTear";
import { Box } from "@mittwald/flow-components/dist/components/Box";
import { Icon } from "@mittwald/flow-components/dist/components/Icon";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import { TranslationProvider } from "@mittwald/flow-components/dist/components/TranslationProvider";
import type { FC } from "react";
import React from "react";
import config from "../config";

export const WidgetErrorView: FC = () => (
  <TranslationProvider name="WidgetErrorView" type="component">
    <Box _height={config.defaultHeight} _position="relative">
      <Box
        _alignItems="center"
        _flexDirection="column"
        _position="centerAbsolute"
      >
        <Icon _color="label" _size="xl" icon={faFaceSmileTear} />
        <Text _mt="xl" center i18n="headline" strong />
        <Text center i18n="text" />
      </Box>
    </Box>
  </TranslationProvider>
);

export default WidgetErrorView;
